export const parseTimecode = (raw: string) => {
  const parts = raw.split(":");
  const minutes = parseInt(parts[0], 10);
  const seconds = parseInt(parts[1] ?? "0", 10);
  const fraction = parseFloat(parts[2] ?? "0.0");

  return minutes * 60 + seconds + fraction / 100;
};
